export interface APIDetails {
  url: string;
  success: boolean;
  restMethod: string;
  apiName: string;
  correlationID: string;
  elapsedTime: number;
  body: any;
  payload: any;
  headers: any;
  params: any;
}

export interface SplunkMessage {
  flow: string;
  details?: any;
}

export enum EnumFile {
  SplunkInterceptor = 'SplunkInterceptor',
  APIInterceptor = 'API Interceptor',
  NavigationService = 'NavigationService',
  ErrorInterceptor = 'ErrorInterceptor',
  LoginComponent = 'LoginComponent',
  SigninRedirectCallbackComponent = 'SigninRedirectCallbackComponent',
  DashboardComponent = 'DashboardComponent',
  AgreementsComponent = 'AgreementsComponent',
}

export enum SplunkSourceType {
  PMPUI = 'pmp:ui:logs',
  PMPAPI = 'pmp:api:logs',
}

export enum SplunkLogLevel {
  Info = 'INFO',
  Debug = 'Debug',
  Warn = 'Warn',
  Error = 'ERROR',
}

export abstract class SplunkBase {
  file: EnumFile;
  level: SplunkLogLevel;
  message: SplunkMessage;
  sourcetype: SplunkSourceType;
  apiDetails?: APIDetails;

  private readonly _timestamp: Date;

  get timestamp() {
    return this._timestamp.toLocaleDateString();
  }

  constructor(file: EnumFile, level: SplunkLogLevel, message: SplunkMessage, sourceType: SplunkSourceType, apiDetails?: APIDetails) {
    this.file = file;
    this._timestamp = new Date();
    this.level = level;
    this.message = message;
    this.sourcetype = sourceType;
    this.apiDetails = apiDetails;
  }
}

export class SplunkEvent extends SplunkBase {
  constructor(file: EnumFile, message: SplunkMessage, sourcetype: SplunkSourceType, level: SplunkLogLevel, apiDetails?: APIDetails) {
    super(file, level, message, sourcetype, apiDetails);
  }
}
